import moment from 'moment';

export const formatDateTime = (dateString, format) => {
  if (!dateString) return '';
  return moment(dateString).format(format);
};

export const datesStartOfEndOf = (dateString, mode) => {
  if (!dateString) return '';
  if (mode === 'start') return moment(dateString).startOf('day');
  if (mode === 'end') return moment(dateString).endOf('day');
};
